<template>
  <div>
    <section style="margin-top: 30px">
      <aside class="menu">
        <!--    Agent's dashboard components  -->
        <ul class="menu-list" v-if="departmentAdmin">
<!--          <li><router-link :to="{name:'agentDashboard'}" :class="currentRouteName == 'agentDashboard' ?  'active-item' :'inactive-item'">Dashboard</router-link></li>-->
<!--          <li><router-link :to="{name:'agentPending'}" :class="currentRouteName == 'agentPending' ?  'active-item' :'inactive-item'">Pending</router-link></li>-->
<!--          <li><router-link :to="{name:'agentApproved'}" :class="currentRouteName == 'agentApproved' ?  'active-item' :'inactive-item'">Approved</router-link></li>-->
<!--          <li><router-link :to="{name:'agentDeclined'}" :class="currentRouteName == 'agentDeclined' ?  'active-item' :'inactive-item'">Declined</router-link></li>-->
          <li><router-link :to="{name:'templateList'}" :class="currentRouteName == 'templateList' || currentRouteName == 'templateCreate' ?  'active-item' :'inactive-item'">Templates</router-link></li>
          <li><router-link :to="{name:'activityReportView'}" :class="currentRouteName == 'activityReportView' ?  'active-item' :'inactive-item'">Activity Report</router-link></li>
          <li><router-link :to="{name:'envelopeStatusReportView'}" :class="currentRouteName == 'envelopeStatusReportView' ?  'active-item' :'inactive-item'">Envelope Status Report</router-link></li>
          <li><router-link :to="{name:'activityLog'}" :class="currentRouteName == 'activityLog' ?  'active-item' :'inactive-item'">Activity Log</router-link></li>
          <li><router-link :to="{name:'profileView'}" :class="currentRouteName == 'profileView' ?  'active-item' :'inactive-item'">Profile</router-link></li>
        </ul>

        <ul class="menu-list" v-if="InternaleStaff">
          <li><router-link :to="{name:'agentDashboard'}" :class="currentRouteName == 'agentDashboard' ?  'active-item' :'inactive-item'">Dashboard</router-link></li>
          <li><router-link :to="{name:'allDocumentsView'}" :class="currentRouteName == 'allDocumentsView' ?  'active-item' :'inactive-item'">All</router-link></li>
          <li><router-link :to="{name:'PendingView'}" :class="currentRouteName == 'PendingView' ?  'active-item' :'inactive-item'">Pending</router-link></li>
          <li><router-link :to="{name:'CompletedView'}" :class="currentRouteName == 'CompletedView' ?  'active-item' :'inactive-item'">Completed</router-link></li>
          <li><router-link :to="{name:'declinedView'}" :class="currentRouteName == 'declinedView' ?  'active-item' :'inactive-item'">Declined</router-link></li>
          <li><router-link :to="{name:'expiredView'}" :class="currentRouteName == 'expiredView' ?  'active-item' :'inactive-item'">Expired</router-link></li>
          <li><router-link :to="{name:'assignToMeView'}" :class="currentRouteName == 'assignToMeView' ?  'active-item' :'inactive-item'">Assign to me</router-link></li>
          <li><router-link :to="{name:'templateListView'}" :class="currentRouteName == 'templateListView' ?  'active-item' :'inactive-item'">Templates</router-link></li>

        </ul>



        <!-- Customer's dashboard components -->
        <ul class="menu-list" v-if="isCustomer">
          <li><router-link :to="{name:'customerDashboard'}" :class="currentRouteName == 'customerDashboard' ?  'active-item' :'inactive-item'">Dashboard</router-link></li>
          <li><router-link :to="{name:'customerDashboardPending'}" :class="currentRouteName == 'customerDashboardPending' ?  'active-item' :'inactive-item'">Pending</router-link></li>
          <li><router-link :to="{name:'customerDashboardEsign'}" :class="currentRouteName == 'customerDashboardEsign' ?  'active-item' :'inactive-item'">E-Sign</router-link></li>
          <li><router-link :to="{name:'customerDashboardHistory'}" :class="currentRouteName == 'customerDashboardHistory' ?  'active-item' :'inactive-item'">History</router-link></li>
        </ul>
      </aside>
    </section>
  </div>


</template>

<script>

  export default {
    name:'side-bar',
    data() {
      return {
        departmentAdmin:false,
        InternaleStaff:false,
        Customer:false,
      }
    },

    computed: {
      currentRouteName() {
        return this.$route.name;
      },

    },

    props:{
      'isAgent':{
        default:false
      },

      'isCustomer':{
        default: false
      },
    },

    mounted() {
      this.checkRoles()

    },

    methods:{
      checkRoles:function (){
        var role  = this.$root.user_role
        if(role == 1){
          this.departmentAdmin = true
        }else if(role == 2){
          this.departmentAdmin = false
          this.InternaleStaff = true
        }
      }
    }

  }
</script>

<style scoped>
p {
  color: gray;
  font-weight: 500;
}

.menu-list li a{
  padding: 30px;
  box-shadow: 0px 9px 17px rgba(0, 0, 0, 0.1);
  border-bottom-right-radius: 10px;
  font-weight: bold;
  font-size: 24px;
  text-align: left;
}

.menu-list li a:hover{
  color: #0D5DA3;
}

.active-item{
  color: #0D5DA3;
}

.inactive-item{
  color:#7E7E8F ;
}

span{
  padding: 5px;
  font-size: 15px;
  border-radius: 50%;
  color: white;
  background: linear-gradient(180deg, #3A8FFF 0%, #0D5DA3 100%);
  margin-left: 10px;

}

@media only screen and (max-width: 600px) {




}

</style>
